import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { mixin } from '../helpers/mixins';
import { position } from '../style/position';
import { left } from '../style/left';
import { right } from '../style/right';
import { bottom } from '../style/bottom';
import { top } from '../style/top';
import { zIndex } from '../style/z-index';
import { transform } from '../style/transform';
import { translateY } from '../style/translate-y';
import { translateX } from '../style/translate-x';
import { overflow } from '../style/overflow';
export var positionMixin = css(_templateObject(), mixin(position, 'position'), mixin(overflow, 'overflow'), mixin(top, 'top'), mixin(left, 'left'), mixin(bottom, 'bottom'), mixin(right, 'right'), mixin(zIndex, 'zIndex'), mixin(translateX, 'translateX'), mixin(translateY, 'translateY'), mixin(transform, 'transform'));
export var positionKeys = ['position', 'overflow', 'top', 'left', 'bottom', 'right', 'zIndex', 'translateX', 'translateY', 'transform'];